import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const enableQuotaBeforeUserLimitCheck = getFeature('enable-quota-before-user-limit-check') || false;
